import React from 'react';
class BreadCrumb extends React.Component {
    render(){
        let {cate, event} = this.props;
        let breadCrumbItemsView = cate ? [
            <li key="0" className="breadcrumb-item">
                <a href={event.link} title={event.name}>{event.name}</a>
                <span></span>
            </li>,
            <li key="1" className="breadcrumb-item">
                <strong>{cate.title}</strong>
            </li>
        ]:
        <li className="breadcrumb-item">
            <strong>{event.name}</strong>
        </li>;
        return (
            <div className="container">
                <div className="row">
                    <div className="breadcrumbs">
                        <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                <a href="/" title="Tới trang chủ">Trang chủ</a>
                                    <span></span>
                                </li>
                                {breadCrumbItemsView}
                        </ol>
                    </div>
                </div>
            </div>
        );
    }
}
export default BreadCrumb;